// src/services/utilisateurs.ts
import { api } from "./api";
import type { Utilisateur } from "../types/utilisateur";

// Récupérer le profil de l'utilisateur connecté
export async function getCurrentUser(): Promise<Utilisateur> {
  const response = await api.get("/utilisateurs/me/");
  return response.data;
}

// Récupérer tous les utilisateurs (SuperAdmin)
export async function getAllUsers(): Promise<Utilisateur[]> {
  const response = await api.get("/utilisateurs/");
  return response.data;
}

// Récupérer un utilisateur par ID
export async function getUserById(id: string): Promise<Utilisateur> {
  const response = await api.get(`/utilisateurs/${id}/`);
  return response.data;
}

// Créer un nouvel utilisateur
export async function createUser(formData: FormData): Promise<Utilisateur> {
  const response = await api.post("/utilisateurs/", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
}

// Mettre à jour un utilisateur
export async function updateUser(id: string, formData: FormData): Promise<Utilisateur> {
  const response = await api.put(`/utilisateurs/${id}/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
}


// Supprimer un utilisateur
export async function deleteUser(id: string): Promise<void> {
  await api.delete(`/utilisateurs/${id}/`);
}

// Vérifier le mot de passe du SuperAdmin connecté
export async function verifySuperadminPassword(password: string): Promise<boolean> {
  const response = await api.post("/utilisateurs/verify-password/", { password });
  return response.data.valid;
}

// Récupérer le mot de passe initial d’un utilisateur (réservé aux superadmins)
export async function getUserPassword(userId: string, superadminPassword: string): Promise<string | null> {
  const response = await api.post(`/utilisateurs/${userId}/get-password/`, {
    password: superadminPassword,
  });
  if (response.data.valid) {
    return response.data.password;
  }
  return null;
}
